module.exports = __webpack_public_path__ + "img/img25.f757855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img25.jpg
// module id = 322
// module chunks = 0